import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "ps-panel" }
const _hoisted_2 = { class: "notif-status-icon" }
const _hoisted_3 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_4 = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_5 = {
  key: 2,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_6 = { class: "notif-status-text" }
const _hoisted_7 = {
  key: 0,
  class: "notif-status-label"
}
const _hoisted_8 = {
  key: 1,
  class: "notif-status-label"
}
const _hoisted_9 = {
  key: 2,
  class: "notif-status-label"
}
const _hoisted_10 = {
  key: 3,
  class: "notif-status-desc"
}
const _hoisted_11 = {
  key: 4,
  class: "notif-status-desc"
}
const _hoisted_12 = {
  key: 5,
  class: "notif-status-desc"
}
const _hoisted_13 = {
  key: 0,
  class: "notif-alert notif-alert--warn"
}
const _hoisted_14 = {
  key: 1,
  class: "notif-alert notif-alert--info"
}
const _hoisted_15 = {
  key: 2,
  class: "notif-toggle-row"
}
const _hoisted_16 = { class: "notif-toggle-info" }
const _hoisted_17 = { class: "notif-toggle-desc" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["aria-checked"]
const _hoisted_21 = {
  key: 3,
  class: "ps-panel-ft"
}
const _hoisted_22 = {
  key: 4,
  class: "compat-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "ps-panel-hd" }, [
      _createElementVNode("h2", null, "Notificações"),
      _createElementVNode("p", null, "Receba alertas mesmo com o aplicativo fechado, em qualquer dispositivo.")
    ], -1)),
    _createElementVNode("div", {
      class: _normalizeClass(["notif-status-card", _ctx.webPushActive ? 'notif-status-card--active' : _ctx.pushEnabled ? 'notif-status-card--basic' : 'notif-status-card--off'])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.webPushActive)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
            ]))]))
          : (_ctx.pushEnabled)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("path", { d: "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" }, null, -1),
                _createElementVNode("path", { d: "M13.73 21a2 2 0 0 1-3.46 0" }, null, -1)
              ]))]))
            : (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("line", {
                  x1: "1",
                  y1: "1",
                  x2: "23",
                  y2: "23"
                }, null, -1),
                _createElementVNode("path", { d: "M17 17H3s3-2 3-9a4.67 4.67 0 0 1 .3-1.7M9 21a3 3 0 0 0 6 0m6.43-6.43A9.07 9.07 0 0 0 18 9" }, null, -1)
              ]))]))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.webPushActive)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Notificações em background ativas"))
          : (_ctx.pushEnabled)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Apenas com app aberto"))
            : (_openBlock(), _createElementBlock("span", _hoisted_9, "Notificações desabilitadas")),
        (_ctx.webPushActive)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Você receberá alertas mesmo com o navegador fechado."))
          : (_ctx.pushEnabled)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Ativas somente enquanto esta aba estiver aberta no navegador."))
            : (_openBlock(), _createElementBlock("span", _hoisted_12, "Ative abaixo para receber alertas do sistema."))
      ])
    ], 2),
    (_ctx.pushPermission === 'denied')
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2"
          }, [
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "10"
            }),
            _createElementVNode("line", {
              x1: "12",
              y1: "8",
              x2: "12",
              y2: "12"
            }),
            _createElementVNode("line", {
              x1: "12",
              y1: "16",
              x2: "12.01",
              y2: "16"
            })
          ], -1),
          _createElementVNode("span", null, [
            _createTextVNode("O navegador bloqueou as notificações. Clique no ícone de cadeado (🔒) na barra de endereço, vá em "),
            _createElementVNode("strong", null, "Configurações do site"),
            _createTextVNode(" e mude "),
            _createElementVNode("strong", null, "Notificações"),
            _createTextVNode(" para "),
            _createElementVNode("em", null, "Permitir"),
            _createTextVNode(".")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.isIOS && !_ctx.isPWA && _ctx.isSupported)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[7] || (_cache[7] = [
          _createStaticVNode("<svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-5e14f80e><circle cx=\"12\" cy=\"12\" r=\"10\" data-v-5e14f80e></circle><line x1=\"12\" y1=\"16\" x2=\"12\" y2=\"12\" data-v-5e14f80e></line><line x1=\"12\" y1=\"8\" x2=\"12.01\" y2=\"8\" data-v-5e14f80e></line></svg><div data-v-5e14f80e><strong data-v-5e14f80e>iPhone / iPad:</strong> para receber notificações em background, instale o app na tela inicial: <ol class=\"notif-steps\" data-v-5e14f80e><li data-v-5e14f80e>Toque em <strong data-v-5e14f80e>Compartilhar</strong> no Safari</li><li data-v-5e14f80e>Selecione <strong data-v-5e14f80e>Adicionar à Tela de Início</strong></li><li data-v-5e14f80e>Abra o app pela tela inicial e ative as notificações aqui</li></ol><p style=\"margin:4px 0 0;font-size:12px;color:var(--ink-muted);\" data-v-5e14f80e>Exige iOS 16.4 ou superior.</p></div>", 2)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.isSupported && _ctx.pushPermission !== 'denied')
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "notif-toggle-label" }, "Receber notificações", -1)),
            _createElementVNode("span", _hoisted_17, [
              (_ctx.isWebPushSupported)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Alertas em background via Web Push"))
                : (_openBlock(), _createElementBlock("span", _hoisted_19, "Alertas enquanto o app estiver aberto"))
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["push-toggle-btn", { active: _ctx.pushEnabled }]),
            role: "switch",
            "aria-checked": _ctx.pushEnabled,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglePush && _ctx.togglePush(...args)))
          }, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("span", { class: "push-toggle-thumb" }, null, -1)
          ]))], 10, _hoisted_20)
        ]))
      : _createCommentVNode("", true),
    (_ctx.pushPermission === 'default' && _ctx.isSupported)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("button", {
            class: "btn btn-primary btn-login",
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.askPushPermission && _ctx.askPushPermission(...args)))
          }, " Permitir notificações ")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      class: "compat-toggle",
      type: "button",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showCompat = !_ctx.showCompat))
    }, [
      _cache[11] || (_cache[11] = _createElementVNode("svg", {
        width: "13",
        height: "13",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [
        _createElementVNode("circle", {
          cx: "12",
          cy: "12",
          r: "10"
        }),
        _createElementVNode("line", {
          x1: "12",
          y1: "16",
          x2: "12",
          y2: "12"
        }),
        _createElementVNode("line", {
          x1: "12",
          y1: "8",
          x2: "12.01",
          y2: "8"
        })
      ], -1)),
      _cache[12] || (_cache[12] = _createTextVNode(" Consultar compatibilidade com o seu sistema ", -1)),
      (_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(["compat-chevron", { open: _ctx.showCompat }]),
        width: "11",
        height: "11",
        viewBox: "0 0 11 11",
        fill: "none"
      }, [...(_cache[10] || (_cache[10] = [
        _createElementVNode("path", {
          d: "M2 4l3.5 3.5L9 4",
          stroke: "currentColor",
          "stroke-width": "1.4",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, -1)
      ]))], 2))
    ]),
    (_ctx.showCompat)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [...(_cache[13] || (_cache[13] = [
          _createStaticVNode("<p data-v-5e14f80e><strong data-v-5e14f80e>Android (Chrome)</strong> — notificações em background completo, mesmo com o Chrome fechado. O sistema operacional mantém uma conexão permanente com o servidor de push do Google (FCM).</p><p data-v-5e14f80e><strong data-v-5e14f80e>Windows (Chrome / Edge)</strong> — funciona com o navegador minimizado ou em segundo plano. O browser precisa estar rodando, mas não precisa estar em foco.</p><p data-v-5e14f80e><strong data-v-5e14f80e>Mac (Chrome / Firefox)</strong> — mesmo comportamento do Windows. Safari no Mac suporta a partir do macOS 13 Ventura.</p><p data-v-5e14f80e><strong data-v-5e14f80e>iPhone / iPad (Safari)</strong> — requer iOS 16.4 ou superior <em data-v-5e14f80e>e</em> o app instalado na tela inicial como PWA. Sem o PWA instalado, o Safari não permite push em background. Veja as instruções acima para instalar.</p><p class=\"compat-note\" data-v-5e14f80e>O seu dispositivo atual está destacado na lista. Notificações em background usam o protocolo Web Push (VAPID) — o mesmo mecanismo que WhatsApp e outros apps utilizam.</p>", 5)
        ]))]))
      : _createCommentVNode("", true)
  ]))
}